import * as React from 'react';
import { AbstractSharingLink } from './AbstractSharingLink';

export class Facebook extends AbstractSharingLink {
    public render() {
        const titleAttribute = this.context.i18n.translate('Auf Facebook teilen');
        const model = this.props.model;
        const localUrl = encodeURIComponent(this.buildSharingUri(model));
        const title = encodeURIComponent(model.title);
        const uri = `http://www.facebook.com/sharer.php?`
            + `u=${localUrl}&`
            + `p[title]=${title}`;

        return <div className="jc-share-link -facebook">
            <a href={uri} target="_blank" rel="noopener noreferrer" title={titleAttribute}>
                <i className="fab fa-facebook-f"/>
            </a>
        </div>;
    }
}
